exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tbody.numbered-section tr td {\n  vertical-align: top;\n}\ntbody.numbered-section tr td p {\n  margin-bottom: 0.3rem !important;\n}\ntbody.numbered-section tr td:first-child {\n  width: 100%;\n}\ntbody.numbered-section tr td:nth-child(2) {\n  padding-right: 10px;\n  padding-top: 2px;\n  color: #aaa;\n  font-size: 0.8rem;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}", ""]);

// exports
